import {
    CORS_MODE_NAME,
    FetchRequestOptions,
    fetchService,
    GET_METHOD_NAME,
} from 'owa-data-provider-info-fetcher';
import { SharingLinkTypeView, TEXT_DIRECTORY_MIME_TYPE } from 'owa-fileprovider-link-services';
import { BOX_BASE_API_ROUTE } from 'owa-fileprovider-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import SharingLinkKind from 'owa-service/lib/contract/SharingLinkKind';
import { GetBoxSharingInfoResponse } from './GetBoxSharingInfoResponse';

async function getBoxItem(itemUrl: string): Promise<any> {
    const requestUrl: string = `${BOX_BASE_API_ROUTE}/shared_items`;
    const requestOptions: FetchRequestOptions = {
        method: GET_METHOD_NAME,
        mode: CORS_MODE_NAME,
        body: null,
        datapointNamePrefix: 'GetBoxFileInfo',
    };

    const additionalHeaders = {
        BoxApi: 'shared_link=' + itemUrl,
    };

    const responseText: string = await fetchService(
        AttachmentDataProviderType.Box,
        requestUrl,
        null,
        requestOptions,
        additionalHeaders
    );
    return JSON.parse(responseText);
}

export async function getBoxFileInfo(url: string): Promise<GetBoxSharingInfoResponse> {
    const itemResponse = await getBoxItem(url);
    return {
        ResultCode: AttachmentResultCode.Success,
        FileName: itemResponse.name,
        MimeType: itemResponse.type === 'folder' ? TEXT_DIRECTORY_MIME_TYPE : itemResponse.type,
        SharingLinkKind: SharingLinkKind.AnonymousView,
        BlocksDownload: !itemResponse.shared_link.permissions.can_download,
        CanShareExternally: true,
        ExpirationDate: null,
        OriginalUrl: null,
        Type: SharingLinkTypeView,
        providerFileId: itemResponse.id,
        location: url,
    };
}
